var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 112 112"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 56,
  r: 40,
  fill: "#2D2D2B"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M76 56 46 73.32V38.68z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 112,
  height: 112,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "darken",
  result: "effect1_dropShadow_1207_2104"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1207_2104",
  result: "shape"
})))));
export { SvgIconYoutube as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/landingpages/sell_my_car/icon-youtube.svg", import.meta.url).toString();